import { useHookstate } from '@hookstate/core';
import { useCallback } from 'react';
import { Winners } from '../components/CongratulationsPanel';
import { current, meta, winners as winnersState } from '../stores/backend';
import { useCurrentPartsSize } from './use-current-parts-size';
import { useFormatCurrency } from './use-format-currency';
import { useQueuedPulse } from './use-queued-pulse';
import { useWinners } from './use-winners';

export const usePartWinners = () => {
    const $winners = useHookstate(winnersState);
    const $current = useHookstate(current);
    const $meta = useHookstate(meta);

    const currentPart = $current.current_part.value || 0;
    const gamePartDelay = $current.game_partdelay.value;

    const parts = useCurrentPartsSize();

    const qualifies = useCallback(
        (winners?: Winners[]) => {
            return !!winners && winners.length > 0 && currentPart + 1 < parts;
        },
        [currentPart, parts]
    );

    const formatCurrency = useFormatCurrency($current, $meta);

    const winners = useWinners($winners, currentPart, formatCurrency);

    const partWinners = useQueuedPulse(winners, gamePartDelay, qualifies);

    return partWinners;
};
